import { PlusOutlined } from "@ant-design/icons";
import { Modal, Upload } from "antd";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { deleteRequest } from "../../../axios";
import { SuccessNotificationMsg } from "../../../utils/Notifications";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

  // State Initialisation
const SubCategoryImageUpload = ({
  beforeUpload,

  deleteFlag,
  setDeleteFlag,
  setUploadFileProfilePic,
  fileList,
  setFileList,
  identifyProfileUrl,
  setIdentifyProfileUrl,
  categoryTreeId,
}) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");

  //Function on Handle Cancel
  const handleCancel = () => setPreviewOpen(false);
  // Function too handle Preview
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
  };

  // Function to Handle Change
  const handleChange = ({ fileList: newFileList }) => {
    const uploadedFile = newFileList[0]; // Assuming only one file is uploaded at a time
    if (uploadedFile && uploadedFile.originFileObj) {
      setUploadFileProfilePic(uploadedFile.originFileObj);
      setFileList(newFileList);
    }
  };

  // Function to Upload Button
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );

  // Function to Handle Remove File
  const handleRemove = async (file) => {
    if (categoryTreeId && deleteFlag === 0 && identifyProfileUrl !== null) {
      try {
        const apiResponse = await deleteRequest(
          `category-tree-image-delete/${categoryTreeId}/`
        );
        if (apiResponse.data.success) {
          SuccessNotificationMsg("Image deleted successfully");
          setFileList([]);
          setDeleteFlag((deleteFlag) => deleteFlag + 1);
          setUploadFileProfilePic("");
          setIdentifyProfileUrl(null);
        }
      } catch (error) {
        // Handle error appropriately (show message, retry, etc.)
      }
    } else {
      setFileList([]);
      setUploadFileProfilePic("");
      setIdentifyProfileUrl(null);
    }
  };

  return (
    <>
      <Upload
        listType="picture-card"
        fileList={fileList}
        onPreview={handlePreview}
        onChange={handleChange}
        onRemove={handleRemove}
        beforeUpload={beforeUpload}
        accept=".jpg,.png"
      >
        {fileList.length >= 1 ? null : uploadButton}
      </Upload>
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img
          alt="example"
          style={{
            width: "100%",
          }}
          src={previewImage}
        />
      </Modal>
    </>
  );
};

SubCategoryImageUpload.propTypes = {
  deleteFlag: PropTypes.number,
  setDeleteFlag: PropTypes.func.isRequired,
  setUploadFileProfilePic: PropTypes.func.isRequired,
  fileList: PropTypes.array,
  setFileList: PropTypes.func.isRequired,
  identifyProfileUrl: PropTypes.func,
  setIdentifyProfileUrl: PropTypes.func.isRequired,
  beforeUpload: PropTypes.func.isRequired,
  categoryTreeId: PropTypes.number,
};

export default SubCategoryImageUpload;
